import fetch from 'isomorphic-fetch'
import https from 'https'

export const REQUEST_CONTACTS = 'REQUEST_CONTACTS'
export const RECEIVE_CONTACTS = 'RECEIVE_CONTACTS'
export const INVALIDATE_CONTACTS = 'INVALIDATE_CONTACTS'

export const REQUEST_APPROVE = 'REQUEST_APPROVE';
export const RECEIVE_APPROVE = 'RECEIVE_APPROVE';

export const REQUEST_REPLY = 'REQUEST_REPLY';
export const COMPLETE_REPLY = 'COMPLETE_REPLY';

function requestContact(){
  return{
    type: REQUEST_CONTACTS
  }
}

function receiveContact(contacts){
  return {
    type: RECEIVE_CONTACTS,
    contacts,
    receivedAt: Date.now()
  }
}

function requestApprove(){
  return {
    type: REQUEST_APPROVE
  }
}

function receiveApprove(){
  return {
    type: RECEIVE_APPROVE
  }
}

function requestReply(){
  return {
    type: REQUEST_REPLY
  }
}

function receiveReply(){
  return {
    type: COMPLETE_REPLY
  }
}

function fetchContacts(){
  return dispatch => {
    dispatch(requestContact());

    return fetch('https://'+__API_HOST__+__CONTACTS_URL__)
      .then(response => response.json())
      .then( json => dispatch(receiveContact(json.data)) )
  }
}

function shouldFetchContacts(state) {
  const contact = state.contact;

  if (!contact) {
    return true
  } else if (contact.isFetching) {
    return false
  } else {
    return contact.didInvalidate
  }
}

export function fetchMessagesIfNeeded() {
  return (dispatch, getState) => {
    if (shouldFetchContacts(getState())) {
      return dispatch(fetchContacts())
    }
  }
}

export function approveMessage(messageId, isTop){
  return dispatch => {
    dispatch(requestApprove());

    var requestData = {
        'is_top': isTop,
        'is_approve': true
    }

    var options = {
      hostname: __API_HOST__,
      path: __CONTACTS_URL__ + '/' + messageId,
      method: 'PUT'
    };

    var req = https.request(options, (res) => {

      res.on('data', (response) => {

        dispatch(receiveApprove());

        dispatch(fetchMessagesIfNeeded());
      });
    });

    req.on('error', (e) => {
      console.error(e);
    });
    req.write(new Buffer(JSON.stringify(requestData)));
    req.end();

  }
}

export function replyMessage(messageId, replyMessage){
  return dispatch => {
    dispatch(requestReply());

    var requestData = {
      'reply_message_id': messageId,
      'message': replyMessage,
      'nick_name': 'お店あつめ運営事務局',
      'icon_id': 7,
      'is_user': false
    }

    var options = {
      hostname: __API_HOST__,
      path: __CONTACTS_URL__+'/reply',
      method: 'POST'
    };

    var req = https.request(options, (res) => {

      res.on('data', (response) => {

        dispatch(receiveReply());

        dispatch(fetchMessagesIfNeeded());
      });
    });

    req.on('error', (e) => {
      console.error(e);
    });
    req.write(new Buffer(JSON.stringify(requestData)));
    req.end();

  }
}



// WEBPACK FOOTER //
// ./src/actions/ContactAction.js